import type { JsonObject } from "@/lib/api/types";

import { MOCK_TENANT_ID } from "../constants";
import { MOCK_DEVICES } from "../data/devices";

export function randomMockAlertPayload(): JsonObject {
  const templates = [
    "Battery low on field unit",
    "Sample rate degraded",
    "Calibration drift detected",
    "Ingress buffer near capacity",
  ];
  const device = MOCK_DEVICES[Math.floor(Math.random() * MOCK_DEVICES.length)];
  const message = templates[Math.floor(Math.random() * templates.length)] ?? "Mock alert";
  return {
    channel: "alert",
    id: `mock-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    device_id: device?.id ?? null,
    tenant_id: MOCK_TENANT_ID,
    message,
    severity: Math.random() > 0.7 ? "high" : "medium",
    created_at: new Date().toISOString(),
    payload: { source: "mock-stream", device_uid: device?.device_uid ?? null },
  };
}
